export const Endpoints = {
    EndPointAddToBasket : "/api/shop/basket/add",
    EndPointRemoveFromBasket : "/api/shop/basket/remove",
    EndPointBasketList : "/api/shop/basket/list",
    EndPointBasketSummary : "/api/shop/basket/summary",
    EndPointBasketItemCount : "/api/shop/basket/count",
    EndPointBasketRemoveDiscountVoucher : "/api/shop/basket/voucher-remove",

    EndPointAddToBasketRequest : "/api/shop/basket-request/add",
    EndPointRemoveFromBasketRequest : "/api/shop/basket-request/remove",
    EndPointBasketListRequest : "/api/shop/basket-request/list",
    EndPointBasketRequestItemCount : "/api/shop/basket-request/count",

    EndPointAddToWatchList : "/api/shop/watch-list/add",
    EndPointRemoveFromWatchList : "/api/shop/watch-list/remove",

    EndPointShippingProviderServices : "/api/shop/shipping/provider-services",

    EndPointShippingServiceUpdate : "/api/shop/shipping/update-service",

    EndPointApplePayValidation : "/api/shop/apple/validation",
    EndPointApplePayNow : "/api/shop/apple/pay",

    EndPointLocationPostalCode : "/api/shop/location/postal-code",
    EndPointLocationCity: "/api/shop/location/city",
};
